import gql from 'graphql-tag'

const frequenciesFragment = gql`
  fragment CustomerFrequenciesFragment on CustomerFrequencies {
    total,
    billCount,
    totalK,
    creditClientCount,
    creditClientTotal,
    creditClient,
    dateTime,
    interval,
    shopId
  }
`

const query = gql`
query getCustomerFrequencies(
  $periodStart: Date!,
  $periodEnd: Date!,
  $cashRegisterIds: [ID!],
  $timeCheck: Boolean = false
  $interval: Int = 60
  )
  {
    cashAssist {
      getCustomerFrequencies(
        params: {
          periodStart: $periodStart,
          periodEnd: $periodEnd,
          cashRegisterIds: $cashRegisterIds,
          timeCheck: $timeCheck,
          timeStart: "00:00:00Z",
          timeEnd: "21:00:00Z"
          interval: $interval
    }) {
      ...CustomerFrequenciesFragment
    }
  }
}
${frequenciesFragment}
`

export default query
